it("should handle the json loader correctly", function() {
	require("!json!../../../../package.json").name.should.be.eql("webpack");
	require("../../../../package.json").name.should.be.eql("webpack");
});



/*****************
 ** WEBPACK FOOTER
 ** ./loaders/json-loader/index.js
 ** module id = 0
 ** module chunks = 0
 **/